import { useMemo } from "react";
import { createImgproxyUrl, ImgproxyOptions } from "@citychallenge/common";

export const useImgproxy = (origin?: string, options?: ImgproxyOptions) => {
  const url = useMemo(() => {
    if (!origin || !options) return undefined;

    // Block audio files
    if (origin.endsWith("mp3") || origin.endsWith("m4a")) return undefined;
    return createImgproxyUrl(origin, options);
  }, [
    // Note: stringifying is a lot faster than signing urls
    origin,
    options && JSON.stringify(options),
  ]);

  return url;
};
